<template>
  <view-wrap>
    <template>
      <div class="home">
        <div class="hero element lg text-center">
          <h1>Streamline your fantasy basketball experience</h1>
          <p>Straightforward fantasy analytics that save you time and help you win.</p>
          <button @click="login()" class="cta-btn dark hollow">Try it for free</button>
        </div>
      </div>
    </template>
    <template v-slot:full>
      <view-wrap class="bg-light bottom-section">
        <div>
          <div class="feature">
            <h3>Category Strengths</h3>
            <p>See how often you won in each category, compared to every team in the&nbsp;league.</p>
            <img src="./images/2.png">
          </div>
          <div class="feature">
            <h3>Compare Teams</h3>
            <p>Compare your weekly average in each category vs. the league average to identify areas of opportunity.</p>
            <img src="./images/3.png">
          </div>
          <div class="feature">
            <h3>Weekly Performance</h3>
            <p>Compare how you performed against each team in the league, and not just for your matchup. Find out how many teams edge&nbsp;out.</p>
            <img src="./images/1.png">
          </div>
        </div>
        <div class="final-cta element sm">
          <h3>Straightforward fantasy analytics that save you time and help you win.</h3>
          <button @click="login()" class="cta-btn dark hollow">Try it for free</button>
        </div>
      </view-wrap>
    </template>
  </view-wrap>
</template>

<script>

export default {
  name: "home",
  data () {
    return {}
  },
  mounted: async function () {
    await this.$store.dispatch('getUser')
    if (this.$store.getters.currentUser) this.$router.push('toolbox')
  },
  methods: {
    login: function () {
      this.$store.dispatch('login')
    }
  }
};
</script>

<style src="./home.styl" lang="stylus" scoped></style>
